import React, { useState, useEffect } from 'react';
import './RelaysTwo.css';
import RelaysThreeUpdate from "./RelaysThreeUpdate";
import RelaysOneUpdate from "./RelaysOneUpdate";

const RelayTestForm = ({ reportToUpdate, isUpdateMode }) => {
  const [formData, setFormData] = useState({});
  const [showBackPage, setShowBackPage] = useState(false);
  const [showNextPage, setShowNextPage] = useState(false);
  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});
  
  const [settings, setSettings] = useState({
    oc1_ansiCode: '',
    oc1_setValue: '',
    oc1_curveType: '',
    oc1_time: '',
    oc2_ansiCode: '',
    oc2_setValue: '',
    oc2_curveType: '',
    oc2_time: '',
    ef1_ansiCode: '',
    ef1_setValue: '',
    ef1_curveType: '',
    ef1_time: '',
    ef2_ansiCode: '',
    ef2_setValue: '',
    ef2_curveType: '',
    ef2_time: '',
  });
  
  const [operationalTimeData, setOperationalTimeData] = useState({
    oc1: {
      phase: 'R, Y, B',
      setCurrent: '',
      setTime: '',
      injectedCurrent: '',
      operatedTime: '',
    },
    oc2: {
      phase: 'R, Y, B',
      setCurrent: '',
      tms: '',
      injectedCurrent2X: '',
      injectedCurrent5X: '',
      injectedCurrent10X: '',
      operatedTime2X: '',
      operatedTime5X: '',
      operatedTime10X: ''
    },
    ef1: {
      phase: 'R - N, Y - N, B - N',
      setCurrent: '',
      setTime: '',
      injectedCurrent: '',
      operatedTime: '',
    },
    ef2: {
      phase: 'R - N, Y - N, B - N',
      setCurrent: '',
      tms: '',
      injectedCurrent2X: '',
      injectedCurrent5X: '',
      injectedCurrent10X: '',
      operatedTime2X: '',
      operatedTime5X: '',
      operatedTime10X: ''
    }
  });

  
  
  const calculateAutoValues = (setCurrent, multiplier) => {
    const setCurrentValue = parseFloat(setCurrent);
    if (isNaN(setCurrentValue) || setCurrentValue <= 0) return '';
    return (setCurrentValue * multiplier).toString();
  };

  const updateAutoCalculatedValues = (section, setCurrent) => {
    if (section === 'oc2' || section === 'ef2') {
      const updatedData = { ...operationalTimeData };
      
      updatedData[section] = {
        ...updatedData[section],
        injectedCurrent2X: calculateAutoValues(setCurrent, 2),
        injectedCurrent5X: calculateAutoValues(setCurrent, 5),
        injectedCurrent10X: calculateAutoValues(setCurrent, 10)
      };
      
      setOperationalTimeData(updatedData);
      localStorage.setItem('updateOperationalTimeData', JSON.stringify(updatedData));
    }
  };
  
  useEffect(() => {

    try {
      const updateDataStr = localStorage.getItem('updateReportData');
      const updateObj = updateDataStr ? JSON.parse(updateDataStr) : undefined;
      const td = updateObj?.test_data || reportToUpdate?.test_data;

      if (td?.relaySettingsData) {
        setSettings(td.relaySettingsData);
        localStorage.setItem('updateRelaySettingsData', JSON.stringify(td.relaySettingsData));
      } else {
        const savedSettings = localStorage.getItem('updateRelaySettingsData');
        if (savedSettings) {
          setSettings(JSON.parse(savedSettings));
        }
      }

      const defaultData = {
        oc1: {
          phase: '',
          setCurrent: '',
          setTime: '',
          injectedCurrent: '',
          operatedTime: '',
        },
        oc2: {
          phase: '',
          setCurrent: '',
          tms: '',
          injectedCurrent2X: '',
          injectedCurrent5X: '',
          injectedCurrent10X: '',
          operatedTime2X: '',
          operatedTime5X: '',
          operatedTime10X: ''
        },
        ef1: {
          phase: '',
          setCurrent: '',
          setTime: '',
          injectedCurrent: '',
          operatedTime: '',
        },
        ef2: {
          phase: '',
          setCurrent: '',
          tms: '',
          injectedCurrent2X: '',
          injectedCurrent5X: '',
          injectedCurrent10X: '',
          operatedTime2X: '',
          operatedTime5X: '',
          operatedTime10X: ''
        }
      };
      let mergedOperational = defaultData;
      if (td?.operationalTimeData) {
        mergedOperational = {
          oc1: { ...defaultData.oc1, ...td.operationalTimeData.oc1 },
          oc2: { ...defaultData.oc2, ...td.operationalTimeData.oc2 },
          ef1: { ...defaultData.ef1, ...td.operationalTimeData.ef1 },
          ef2: { ...defaultData.ef2, ...td.operationalTimeData.ef2 }
        };
        setOperationalTimeData(mergedOperational);
        localStorage.setItem('updateOperationalTimeData', JSON.stringify(mergedOperational));
      } else {
        const savedOperationalTimeData = localStorage.getItem('updateOperationalTimeData');
        if (savedOperationalTimeData) {
          const parsedData = JSON.parse(savedOperationalTimeData);
          const mergedData = {
            oc1: { ...defaultData.oc1, ...parsedData.oc1 },
            oc2: { ...defaultData.oc2, ...parsedData.oc2 },
            ef1: { ...defaultData.ef1, ...parsedData.ef1 },
            ef2: { ...defaultData.ef2, ...parsedData.ef2 }
          };
          setOperationalTimeData(mergedData);
        }
      }


      const savedFormData = localStorage.getItem('updateRelayInspectionData');
      if (savedFormData) {
        setFormData(JSON.parse(savedFormData));
      } else if (td?.relayGeneralData) {
        setFormData(td.relayGeneralData);
        localStorage.setItem('updateRelayInspectionData', JSON.stringify(td.relayGeneralData));
      }

      const savedRows = localStorage.getItem('protectionFunctionsData');
      if (savedRows) {
        setRows(JSON.parse(savedRows));
      }
      const savedGeneralInspection = localStorage.getItem('generalInspectionData');
      if (savedGeneralInspection) {
        setGeneralInspection(JSON.parse(savedGeneralInspection));
      }
    } catch (e) {
    
    }
  }, [reportToUpdate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const next = { ...formData, [name]: value };
    setFormData(next);
    try { localStorage.setItem('updateRelayInspectionData', JSON.stringify(next)); } catch {}
  };

  const handleSettingsChange = (e) => {
    const { name, value } = e.target;
    
    const settingsRegex = /^[a-zA-Z0-9.]*$/;
    
    if (value === '' || settingsRegex.test(value)) {
      setSettings({
        ...settings,
        [name]: value
      });
      
      localStorage.setItem('updateRelaySettingsData', JSON.stringify({
        ...settings,
        [name]: value
      }));
    }
  };
  
  const handleOperationalTimeChange = (section, field, value) => {
    const operationalTimeRegex = /^[0-9.]*$/;
    
    if (value === '' || operationalTimeRegex.test(value)) {
      const updatedData = { ...operationalTimeData };
      
      updatedData[section] = {
        ...updatedData[section],
        [field]: value
      };
      
     
      if (field === 'setCurrent' && (section === 'oc2' || section === 'ef2')) {
        updatedData[section] = {
          ...updatedData[section],
          injectedCurrent2X: calculateAutoValues(value, 2),
          injectedCurrent5X: calculateAutoValues(value, 5),
          injectedCurrent10X: calculateAutoValues(value, 10)
        };
      }
      
      setOperationalTimeData(updatedData);
      localStorage.setItem('updateOperationalTimeData', JSON.stringify(updatedData));
    }
  };
  
  const handlePhaseSelection = (section, phase) => {
    const updatedData = { ...operationalTimeData };
    
    updatedData[section] = {
      ...updatedData[section],
      phase: phase
    };
    
    setOperationalTimeData(updatedData);
    localStorage.setItem('updateOperationalTimeData', JSON.stringify(updatedData));
  };

  const handleBack = () => {
    setShowBackPage(true);
  };

  const handleNext = (e) => {
    e.preventDefault();
    
    localStorage.setItem('updateRelaySettingsData', JSON.stringify(settings));
    localStorage.setItem('updateOperationalTimeData', JSON.stringify(operationalTimeData));
    setShowNextPage(true);
  };

  if (showBackPage) {
    return <RelaysOneUpdate goBack={() => setShowBackPage(false)} savedGeneralFormData={formData} />;
  }

  if (showNextPage) {
    return <RelaysThreeUpdate 
      goBack={() => setShowNextPage(false)} 
      savedGeneralData={{
        formData,
        rows,
        generalInspection,
        settings,
        operationalTimeData
      }} 
    />;
  }

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};
  
  return (
    <div className="ct-5482">
      <div className="ct-5483">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className="ct-5484">SETTINGS</h2>
          <span 
            style={{ 
              display: 'flex',
              justifyContent: 'flex-end',
              fontSize: '20px', 
              fontWeight: '600', 
              color: '#333', 
              cursor: 'pointer',
              marginLeft: '50px',
              marginBottom: '50px'
            }}
            onClick={redirectToHome}
          >
            X
          </span>
        </div>
        <div className="ct-5485">
          <div className="ct-5486">
            <div className="ct-5487"></div>
            <div className="ct-5488">O/C 1</div>
            <div className="ct-5488">O/C 2</div>
            <div className="ct-5488">E/F 1</div>
            <div className="ct-5488">E/F 2</div>
            
            <div className="ct-5489">ANSI Code</div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc1_ansiCode"
                value={settings.oc1_ansiCode || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter O/C 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc2_ansiCode"
                value={settings.oc2_ansiCode || ''}
                onChange={handleSettingsChange}
                maxLength={10}
                placeholder="Enter O/C 2" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef1_ansiCode"
                value={settings.ef1_ansiCode || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef2_ansiCode"
                value={settings.ef2_ansiCode || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 2" 
              />
            </div>
            
            <div className="ct-5489">Set Value</div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc1_setValue"
                value={settings.oc1_setValue || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter O/C 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc2_setValue"
                value={settings.oc2_setValue || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter O/C 2" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef1_setValue"
                value={settings.ef1_setValue || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef2_setValue"
                value={settings.ef2_setValue || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 2" 
              />
            </div>
            
            <div className="ct-5489">Curve Type</div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc1_curveType"
                value={settings.oc1_curveType || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter O/C 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc2_curveType"
                value={settings.oc2_curveType || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter O/C 2" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef1_curveType"
                value={settings.ef1_curveType || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef2_curveType"
                value={settings.ef2_curveType || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 2" 
              />
            </div>
            
            <div className="ct-5489">TIME</div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc1_time"
                value={settings.oc1_time || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter O/C 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="oc2_time"
                value={settings.oc2_time || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter O/C 2" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef1_time"
                value={settings.ef1_time || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 1" 
              />
            </div>
            <div className="ct-5490">
              <input 
                type="text" 
                name="ef2_time"
                value={settings.ef2_time || ''}
                maxLength={10}
                onChange={handleSettingsChange}
                placeholder="Enter E/F 2" 
              />
            </div>
          </div>
        </div>
      </div>

      <div className="ct-5491">
        <h2 className="ct-5484">OPERATIONAL TIME CHARACTERISTIC CHECK</h2>
        
        {/* O/C 1 Section */}
        <div className="ct-5492">
          <div className="ct-5493">
            <div className="ct-5494">
              <div className="ct-5495">Reference</div>
              <div className="ct-5497">Phase</div>
              <div className="ct-5498">Set Current(A)</div>
              <div className="ct-5499">Set Time(mSec)</div>
              <div className="ct-5500">Injected Current(A)</div>
              <div className="ct-5501">Operated Time(mSec)</div>
            </div>
            
            <div className="ct-5502">
              <div className="ct-5503">O/C 1</div>
              <div className="ct-5504">
                <button 
                  className={`ct-5505 ${operationalTimeData.oc1.phase === 'R' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc1', 'R')}
                >R</button>
                <button 
                  className={`ct-5505 ${operationalTimeData.oc1.phase === 'Y' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc1', 'Y')}
                >Y</button>
                <button 
                  className={`ct-5505 ${operationalTimeData.oc1.phase === 'B' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc1', 'B')}
                >B</button>
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc1.setCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc1', 'setCurrent', e.target.value)}
                  placeholder="Enter Set Current(A)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc1.setTime || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc1', 'setTime', e.target.value)}
                  placeholder="Enter Set Time(mSec)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc1.injectedCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc1', 'injectedCurrent', e.target.value)}
                  placeholder="Enter Injected Current(A)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc1.operatedTime || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc1', 'operatedTime', e.target.value)}
                  placeholder="Enter Operated Time(mSec)" 
                />
              </div>
            </div>
          </div>
        </div>
        
        {/* O/C 2 Section */}
        <div className="ct-5492">
          <div className="ct-5493">
            <div className="ct-5494">
              <div className="ct-5495">Reference</div>
              <div className="ct-5497">Phase</div>
              <div className="ct-5498">Set Current(A)</div>
              <div className="ct-5508">TMS</div>
              <div className="ct-5500">Injected Current(A)</div>
              <div className="ct-5501">Operated Time(mSec)</div>
            </div>
            
            <div className="ct-5502">
              <div className="ct-5503">O/C 2</div>
              <div className="ct-5504">
                <button 
                  className={`ct-5505 ${operationalTimeData.oc2.phase === 'R' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc2', 'R')}
                >R</button>
                <button 
                  className={`ct-5505 ${operationalTimeData.oc2.phase === 'Y' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc2', 'Y')}
                >Y</button>
                <button 
                  className={`ct-5505 ${operationalTimeData.oc2.phase === 'B' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('oc2', 'B')}
                >B</button>
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.setCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc2', 'setCurrent', e.target.value)}
                  placeholder="Enter Set Current(A)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.oc2.tms || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('oc2', 'tms', e.target.value)}
                  placeholder="Enter TMS" 
                />
              </div>
              <div className="ct-5513">
                <div className="ct-5510">
                  <button className="ct-5511">2X</button>
                  <button className="ct-5511">5X</button>
                  <button className="ct-5511">10X</button>
                </div>
                <div className='ct-5520'>
                  <input 
                    type="text" 
                    value={operationalTimeData.oc2.injectedCurrent2X || ''}
                    maxLength={10}
                    onChange={(e) => handleOperationalTimeChange('oc2', 'injectedCurrent2X', e.target.value)}
                    placeholder="Enter Injected Current(A)" 
                    readOnly
                  />
                  <input 
                    type="text" 
                    value={operationalTimeData.oc2.injectedCurrent5X || ''}
                    maxLength={10}
                    onChange={(e) => handleOperationalTimeChange('oc2', 'injectedCurrent5X', e.target.value)}
                    placeholder="Enter Injected Current(A)"
                    readOnly
                  />
                  <input 
                    type="text" 
                    value={operationalTimeData.oc2.injectedCurrent10X || ''}
                    maxLength={10}
                    onChange={(e) => handleOperationalTimeChange('oc2', 'injectedCurrent10X', e.target.value)}
                    placeholder="Enter Injected Current(A)" 
                    readOnly
                  />
                </div>
              </div>
              <div className="ct-5513">
                <div className="ct-5510">
                  <button className="ct-5511">2X</button>
                  <button className="ct-5511">5X</button>
                  <button className="ct-5511">10X</button>
                </div>
                <div className='ct-5520'>
                  <input 
                    type="text" 
                    value={operationalTimeData.oc2.operatedTime2X || ''}
                    maxLength={10}
                    onChange={(e) => handleOperationalTimeChange('oc2', 'operatedTime2X', e.target.value)}
                    placeholder="Enter Operated Time(mSec)" 
                  />
                  <input 
                    type="text" 
                    value={operationalTimeData.oc2.operatedTime5X || ''}
                    maxLength={10}
                    onChange={(e) => handleOperationalTimeChange('oc2', 'operatedTime5X', e.target.value)}
                    placeholder="Enter Operated Time(mSec)"
                  />
                  <input 
                    type="text" 
                    value={operationalTimeData.oc2.operatedTime10X || ''}
                    maxLength={10}
                    onChange={(e) => handleOperationalTimeChange('oc2', 'operatedTime10X', e.target.value)}
                    placeholder="Enter Operated Time(mSec)" 
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* E/F 1 Section */}
        <div className="ct-5492">
          <div className="ct-5493">
            <div className="ct-5494">
              <div className="ct-5495">Reference</div>
              <div className="ct-5497">Phase</div>
              <div className="ct-5498">Set Current(A)</div>
              <div className="ct-5499">Set Time(mSec)</div>
              <div className="ct-5500">Injected Current(A)</div>
              <div className="ct-5501">Operated Time(mSec)</div>
            </div>
            
            <div className="ct-5502">
              <div className="ct-5503">E/F 1</div>
              <div className="ct-5504">
                <button 
                  className={`ct-5505 ct-5512 ${operationalTimeData.ef1.phase === 'R-N' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef1', 'R-N')}
                >R - N</button>
                <button 
                  className={`ct-5505 ct-5512 ${operationalTimeData.ef1.phase === 'Y-N' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef1', 'Y-N')}
                >Y - N</button>
                <button 
                  className={`ct-5505 ct-5512 ${operationalTimeData.ef1.phase === 'B-N' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef1', 'B-N')}
                >B - N</button>
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef1.setCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef1', 'setCurrent', e.target.value)}
                  placeholder="Enter Set Current(A)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef1.setTime || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef1', 'setTime', e.target.value)}
                  placeholder="Enter Set Time(mSec)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef1.injectedCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef1', 'injectedCurrent', e.target.value)}
                  placeholder="Enter Injected Current(A)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef1.operatedTime || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef1', 'operatedTime', e.target.value)}
                  placeholder="Enter Operated Time(mSec)" 
                />
              </div>
            </div>
          </div>
        </div>
        
        {/* E/F 2 Section */}
        <div className="ct-5492">
          <div className="ct-5493">
            <div className="ct-5494">
              <div className="ct-5495">Reference</div>
              <div className="ct-5497">Phase</div>
              <div className="ct-5498">Set Current(A)</div>
              <div className="ct-5508">TMS</div>
              <div className="ct-5500">Injected Current(A)</div>
              <div className="ct-5501">Operated Time(mSec)</div>
            </div>
            
            <div className="ct-5502">
              <div className="ct-5503">E/F 2</div>
              <div className="ct-5504">
                <button 
                  className={`ct-5505 ${operationalTimeData.ef2.phase === 'R-N' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef2', 'R-N')}
                >R - N</button>
                <button 
                  className={`ct-5505 ${operationalTimeData.ef2.phase === 'Y-N' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef2', 'Y-N')}
                >Y - N</button>
                <button 
                  className={`ct-5505 ${operationalTimeData.ef2.phase === 'B-N' ? 'ct-5506' : ''}`}
                  onClick={() => handlePhaseSelection('ef2', 'B-N')}
                >B - N</button>
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.setCurrent || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef2', 'setCurrent', e.target.value)}
                  placeholder="Enter Set Current(A)" 
                />
              </div>
              <div className="ct-5507">
                <input 
                  type="text" 
                  value={operationalTimeData.ef2.tms || ''}
                  maxLength={10}
                  onChange={(e) => handleOperationalTimeChange('ef2', 'tms', e.target.value)}
                  placeholder="Enter TMS" 
                />
              </div>
              <div className="ct-5513">
                <div className="ct-5510">
                  <button className="ct-5511">2X</button>
                  <button className="ct-5511">5X</button>
                  <button className="ct-5511">10X</button>
                </div>
                <div className='ct-5520'>
                  <input 
                    type="text" 
                    value={operationalTimeData.ef2.injectedCurrent2X || ''}
                    maxLength={10}
                    onChange={(e) => handleOperationalTimeChange('ef2', 'injectedCurrent2X', e.target.value)}
                    placeholder="Enter Injected Current(A)" 
                    readOnly
                  />
                  <input 
            type="text" 
            value={operationalTimeData.ef2.injectedCurrent5X || ''}
            maxLength={10}
            onChange={(e) => handleOperationalTimeChange('ef2', 'injectedCurrent5X', e.target.value)}
            placeholder="Enter Injected Current(A)"
            readOnly
          />
          <input 
            type="text" 
            value={operationalTimeData.ef2.injectedCurrent10X || ''}
            maxLength={10}
            onChange={(e) => handleOperationalTimeChange('ef2', 'injectedCurrent10X', e.target.value)}
            placeholder="Enter Injected Current(A)" 
            readOnly
          />
        </div>
      </div>
      <div className="ct-5513">
        <div className="ct-5510">
          <button className="ct-5511">2X</button>
          <button className="ct-5511">5X</button>
          <button className="ct-5511">10X</button>
        </div>
        <div className='ct-5520'>
          <input 
            type="text" 
            value={operationalTimeData.ef2.operatedTime2X || ''}
            maxLength={10}
            onChange={(e) => handleOperationalTimeChange('ef2', 'operatedTime2X', e.target.value)}
            placeholder="Enter Operated Time(mSec)" 
          />
          <input 
            type="text" 
            value={operationalTimeData.ef2.operatedTime5X || ''}
            maxLength={10}
            onChange={(e) => handleOperationalTimeChange('ef2', 'operatedTime5X', e.target.value)}
            placeholder="Enter Operated Time(mSec)"
          />
          <input 
            type="text" 
            value={operationalTimeData.ef2.operatedTime10X || ''}
            maxLength={10}
            onChange={(e) => handleOperationalTimeChange('ef2', 'operatedTime10X', e.target.value)}
            placeholder="Enter Operated Time(mSec)" 
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div className="ct-5514">
  <button type="button" onClick={handleBack} className="ct-5515">Back</button>
  <button type="button" onClick={handleNext} className="ct-5515">Next</button>
</div>
</div>
    </div>
  );
};

export default RelayTestForm;




